import React from "react";
import { useLocation } from "react-router-dom";

import CompanyProfile from "@/app/pages/companyProfile";
import IndustryAnalysis from "@/app/pages/industryAnalysis";
import CompanyInformation from "@/app/pages/companyInformation";

import ContactProfile from "@/app/pages/contactProfile";
import ContactIndustrySearch from "@/app/pages/contactIndustrySearch"

const DynamicCommonRoutesComponent = (props) => {
  const { pathname } = useLocation(); 

  if (pathname.includes("company-profile")) {
    return <CompanyProfile {...props} />
  }
  if (pathname.includes("industry-analysis")) {
    return <IndustryAnalysis />
  }
  if (pathname.includes("company-information")) {
    return <CompanyInformation />
  }
  if (pathname.includes("contact-profile")) {
    return <ContactProfile />;
  }
  if (pathname.includes("contact-industry-search")) {
    return <ContactIndustrySearch />;
  }
  
  return <div>Contact Directory</div>;
}

export default DynamicCommonRoutesComponent;